var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNoUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9118 1.00316C11.8215 1.01292 11.7371 1.05291 11.6722 1.11664L1.54692 11.2483C1.48685 11.3081 1.44714 11.3853 1.43342 11.4689L1.0047 14.18C0.995054 14.2426 1.0003 14.3067 1.02002 14.3669C1.03974 14.4272 1.07337 14.4819 1.11819 14.5267C1.16302 14.5715 1.21777 14.6052 1.27801 14.6249C1.33826 14.6446 1.4023 14.6498 1.46495 14.6402L4.17597 14.2115C4.25887 14.1995 4.33599 14.1621 4.39665 14.1043L14.5283 3.97267C14.5662 3.93514 14.5963 3.89046 14.6169 3.84122C14.6374 3.79198 14.648 3.73916 14.648 3.6858C14.648 3.63245 14.6374 3.57962 14.6169 3.53038C14.5963 3.48114 14.5662 3.43647 14.5283 3.39894L12.246 1.11664C12.2025 1.07365 12.1499 1.04109 12.092 1.02143C12.0341 1.00177 11.9725 0.995528 11.9118 1.00316ZM11.956 1.97408L13.6708 3.68896L12.9584 4.40139L11.2435 2.68651L11.956 1.97408ZM10.6698 3.26024L12.3847 4.97511L4.39665 12.9632L2.68177 11.2483L10.6698 3.26024ZM2.18369 11.885L3.75986 13.4612L1.88736 13.7575L2.18369 11.885Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoUnderline);
export default __webpack_public_path__ + "static/media/edit-no-underline.29dfd317491dc7467d46413e840d3671.svg";
export { ForwardRef as ReactComponent };